import { IQualiferService } from "../../service/formconfiguration/QualifierService";

export default class InvalidateQualifierInteractor {
  private qualifierService: IQualiferService;

  constructor(qualifierService) {
    this.qualifierService = qualifierService;
  }

  async execute(id: number) {
    await this.qualifierService.invalidateQualifier(id);
  }
}
